module.exports = __webpack_public_path__ + "assets/2b31d9bd60728483406463ba8a51063f.png";